import Backbone from 'backbone';

import {MinimalAlignmentRowsView} from 'analyses/alignment/PolymerAlignmentTabView';
import {ProteinAlignmentRow} from 'constants/AlignmentConstants';
import ProteinAlignmentRowView from 'molbio/proteins/alignments/ProteinAlignmentRowView';
import ProteinAlignmentTabState from 'molbio/proteins/alignments/ProteinAlignmentTabState';

export default class ProteinAlignmentRowsView
  extends Backbone.View<ProteinAlignmentTabState>
  implements MinimalAlignmentRowsView
{
  rowViews!: Array<ProteinAlignmentRowView>;
  rowsContainer!: HTMLDivElement;

  static initClass(): void {
    this.prototype.className = 'scrolling-alignment-rows';
  }

  update(): void {
    if (this.rowViews) {
      this.rowViews.forEach((rowView) => {
        rowView.remove();
      });
    }
    this.rowViews = this.model
      .get('alignment')!
      .rows.map((row: ProteinAlignmentRow, i: number) => ({row, i}))
      .filter(({i}: {i: number}) => i !== 0)
      .map(
        ({row, i}: {row: ProteinAlignmentRow; i: number}): ProteinAlignmentRowView =>
          new ProteinAlignmentRowView({
            model: this.model,
            tabstate: this.model,
            row,
            visibilityOptions: this.model.get('localVisibilityOptionsList')![i],
          })
      );
    this.rowViews.forEach((rowView) => {
      this.rowsContainer.appendChild(rowView.render().el);
    });
  }

  resizeSVGs(): void {
    this.rowViews.forEach((view) => {
      view.setSVGWidth();
    });
  }

  showRange(left: null | number = null): void {
    this.rowViews.forEach((view) => {
      view.showRange(left);
    });
  }

  render(): this {
    this.rowsContainer = document.createElement('div');
    this.el.appendChild(this.rowsContainer);
    this.update();
    return this;
  }

  die(): void {
    this.rowViews.forEach((rowView) => {
      rowView.die();
    });
  }

  remove(): this {
    this.die();
    super.remove();
    return this;
  }
}

ProteinAlignmentRowsView.initClass();
